export default function Login() {
  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <div className="max-w-md mx-auto px-6 py-24" data-testid="login-page">
      <div className="overline text-[#FFB800]">Sign in</div>
      <h1 className="font-display text-4xl mt-2">Access your car care hub.</h1>
      <p className="text-zinc-400 text-sm mt-3">Sign in with Google to view quotes, invoices, warranties and live job status.</p>
      <button onClick={login} className="btn-primary mt-8 w-full justify-center" data-testid="google-login-btn">
        Continue with Google
      </button>
    </div>
  );
}
